exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-reportManagement-ReportLayoutInfo-header{color:#15284b}.src-components-reportManagement-ReportLayoutInfo-description{color:#929292}.src-components-reportManagement-ReportLayoutInfo-disabled{opacity:.3}.src-components-reportManagement-ReportLayoutInfo-reportContainer{border:2px solid #b3b3b3 !important;border-radius:0 !important}", ""]);

// exports
exports.locals = {
	"header": "src-components-reportManagement-ReportLayoutInfo-header",
	"description": "src-components-reportManagement-ReportLayoutInfo-description",
	"disabled": "src-components-reportManagement-ReportLayoutInfo-disabled",
	"reportContainer": "src-components-reportManagement-ReportLayoutInfo-reportContainer"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/reportManagement/ReportLayoutInfo/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/reportManagement/ReportLayoutInfo/styles.scss
// module chunks = 1